import React from 'react';

import { FadeSlideIn } from './Animations';
import { cn } from './cn';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  /** Disable the entrance animation */
  noAnimation?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, className, noAnimation = false, ...props }, ref) => {
    if (noAnimation) {
      return (
        <div ref={ref} className={cn('rounded-lg border border-border bg-surface p-5', className)} {...props}>
          {children}
        </div>
      );
    }
    // Extract only the props that are safe to forward to FadeSlideIn (motion.div).
    // React HTML event handlers like onDrag conflict with framer-motion's onDrag type.
    const { onDrag, onDragStart, onDragEnd, onDragOver, onAnimationStart, onAnimationEnd, ...safeProps } = props;
    return (
      <FadeSlideIn ref={ref} className={cn('rounded-lg border border-border bg-surface p-5', className)} {...safeProps}>
        {children}
      </FadeSlideIn>
    );
  }
);
Card.displayName = 'Card';
